import { useState } from 'react';
import { BlockButton } from '@/components/BlockButton';
import { useAtom } from 'jotai';
import { currentSelectjobChangeProcessLogStatusAtom } from '../../atoms/jobChangeProcess';
import useUpdateJobChangeProcess from '../../api/useUpdateJobChangeProcess';
import { showSuccessToast, showErrorToast } from '../../lib/toast';
type Props = {
  close: () => void;
  jobchangeProcessesRefetch: () => Promise<void>;
};

export default function LogStatusConfirmModalContents({ close, jobchangeProcessesRefetch }: Props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [currentSelectjobChangeProcessLogStatus, setCurrentSelectjobChangeProcessLogStatus] =
    useAtom(currentSelectjobChangeProcessLogStatusAtom);
  const { mutateAsync } = useUpdateJobChangeProcess();

  const onSubmit = async () => {
    setIsSubmit(true);
    try {
      await mutateAsync({
        jobChangeProcessId: currentSelectjobChangeProcessLogStatus!.jobChangeProcessId,
        latestLogId: currentSelectjobChangeProcessLogStatus!.latestLogId,
        result: currentSelectjobChangeProcessLogStatus!.result,
        interviewed_at: new Date(currentSelectjobChangeProcessLogStatus!.interviewedAt ?? ''),
      });
      showSuccessToast('ステータスを変更しました');
    } catch (error) {
      showErrorToast('ステータスの変更に失敗しました');
    } finally {
      setCurrentSelectjobChangeProcessLogStatus(null);
      setIsSubmit(false);
      await currentSelectjobChangeProcessLogStatus!.refetch();
      await jobchangeProcessesRefetch();
      close();
    }
  };

  return (
    <div className="w-[640px] bg-white">
      <div className="px-6 py-4">
        <p className="text-base font-bold">変更の確認</p>
      </div>
      <div className="border-y border-solid border-border px-6 py-4">
        <p className="text-base">ステータスを変更しますか？</p>
      </div>
      <div className="flex justify-end gap-4 px-6 py-4">
        <div className="w-[94px]">
          <BlockButton
            disabled={isSubmit}
            colorType="white"
            type="button"
            text="キャンセル"
            onClick={(e) => {
              e.stopPropagation();
              close();
            }}
          />
        </div>
        <div className="w-[80px]">
          <BlockButton
            disabled={isSubmit}
            type="button"
            text="変更する"
            onClick={(e) => {
              e.stopPropagation();
              onSubmit();
            }}
          />
        </div>
      </div>
    </div>
  );
}
